import React from 'react';

const TermsOfUse = () => {
    return (
        <div className="mx-auto max-w-6xl mt-20">
            <h1 className="font-semibold text-3xl text-secondary">
                Terms of Use
            </h1>
            <p className="text-secondary mt-4">
                This app was created for personal use. It is not intended for
                commercial use. Please note that the developer is not
                responsible for any data loss or misuse. Use this app at your
                own risk.
            </p>
        </div>
    );
};

export default TermsOfUse;
